// extracted by mini-css-extract-plugin
export default {"wrapper":"dhTrN7y1Fn7tr7d1wVTZ","proLabel":"d3dhCZ0Rpp88HUyVC5td","upgradeLink":"TRiSEK4t0IiyGJi_aGe8","locked":"zYWE2ODqIoOphQ64SxxA","unlock":"rvM5CerVbkur7jyRxYc3"};